// removed by extract-text-webpack-plugin
module.exports = {"AttributeList":"AttributeList","attributeList":"AttributeList","AttributeList__name":"AttributeList__name","attributeListName":"AttributeList__name","AttributeList__value":"AttributeList__value","attributeListValue":"AttributeList__value","AttributeList__divider":"AttributeList__divider","attributeListDivider":"AttributeList__divider","AttributeList__divider__label":"AttributeList__divider__label","attributeListDividerLabel":"AttributeList__divider__label"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContentSection/AttributeList.scss
// module id = 502
// module chunks = 0